import { CreditsPanel } from 'features/credits/components/credits-panel';

export const CreditsTab = () => (
  <div className="h-full overflow-auto bg-background">
    <div className="max-w-4xl px-4 py-4 sm:px-6 sm:py-5 md:px-8">
      <CreditsPanel />
    </div>
  </div>
);
